import axios from 'axios'
import { Class } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
})

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface CreateClassRequest {
  name: string
  school: string
  teachers?: string[]
  students?: string[]
}

export interface UpdateClassRequest extends Partial<CreateClassRequest> {
  _id: string
}

export interface ClassesResponse {
  success: boolean
  data: Class[]
}

export interface ClassResponse {
  success: boolean
  data: Class
}

export const getClasses = async (): Promise<Class[]> => {
  const response = await api.get<ClassesResponse>('/classes')
  return response.data.data
}

export const createClass = async (
  classData: CreateClassRequest,
): Promise<Class> => {
  const response = await api.post<ClassResponse>('/classes', classData)
  return response.data.data
}

export const updateClass = async (
  classData: UpdateClassRequest,
): Promise<Class> => {
  const { _id, ...updateData } = classData
  const response = await api.put<ClassResponse>(`/classes/${_id}`, updateData)
  return response.data.data
}

export const deleteClass = async (classId: string): Promise<void> => {
  await api.delete(`/classes/${classId}`)
}

export const addStudentToClass = async (
  classId: string,
  studentId: string,
): Promise<Class> => {
  const response = await api.post<ClassResponse>(
    `/classes/${classId}/students`,
    { studentId },
  )
  return response.data.data
}

export const removeStudentFromClass = async (
  classId: string,
  studentId: string,
): Promise<Class> => {
  const response = await api.delete<ClassResponse>(
    `/classes/${classId}/students/${studentId}`,
  )
  return response.data.data
}

export const updateStudentClasses = async (
  studentId: string,
  classIds: string[],
): Promise<void> => {
  await api.put(`/classes/student/${studentId}`, { classIds })
}
